import PackagesAttributesTemplate from '@order/steps/templates/PackagesAttributes/PackagesAttributesTemplate'
import { StepOption } from '@order/steps/types'
import { Recommendations } from 'recommend/RecommendUtils'

export default function DevPackagesAttributesPage() {
  const recommendations = getRecommendations(options, 3)

  return (
    <PackagesAttributesTemplate
      title="Packages"
      desc="Compare packages and their features available with your prescription and pick one. Tap any feature icon to learn more. Check out our recommendation for you."
      options={options}
      recommendations={recommendations}
    />
  )
}

const getRecommendations = (
  items: StepOption[],
  index: number
): Recommendations => {
  const recommendedOption = items[index]
  const recommendedId = recommendedOption?.variantId ?? recommendedOption?.id

  if (!recommendedOption || !recommendedOption.value || recommendedId == null) {
    return {
      hasRecommendations: false,
      finalId: undefined,
      recommend: [],
      rest: items.map((option) => option.variantId ?? option.id),
    }
  }

  return {
    hasRecommendations: true,
    finalId: undefined,
    recommend: [
      {
        id: recommendedId,
        value: recommendedOption.value,
        option: {
          value: recommendedOption.value,
          requires: null,
          condition: null,
        },
      },
    ],
    rest: items
      .filter((option) => (option.variantId ?? option.id) !== recommendedId)
      .map((option) => option.variantId ?? option.id),
  }
}

const options: StepOption[] = [
  {
    id: 103,
    name: 'packageUpgrade:standard-vf',
    variantId: 212,
    value: 'standard',
    title: 'Standard',
    desc: '',
    lookup: [
      'steps:packageUpgrade.items.standard.vf',
      'steps:packageUpgrade.items.standard.assisted',
      'steps:packageUpgrade.items.standard.vf',
      'steps:packageUpgrade.items.standard',
    ],
    priceDisplayOnly: false,
    price: {
      base: 39,
      discounted: 0,
    },
    stepVariable: 'packageUpgrade',
    recommended: false,
    colors: [],
    select: {
      oId: '103',
      vId: '212',
      val: 'standard',
      var: 'packageUpgrade',
      o: [
        ['coating', 'hc'],
        ['index', 'o150'],
      ],
    },
    nextStep: 34,
    cta: null,
    attributes: [
      {
        id: 1,
        name: 'index_standard',
      },
      {
        id: 5,
        name: 'antiscratch',
      },
    ],
  },
  {
    id: 104,
    name: 'packageUpgrade:comfort-vf',
    variantId: 215,
    value: 'comfort',
    title: 'Comfort',
    desc: '',
    lookup: [
      'steps:packageUpgrade.items.comfort.vf<2',
      'steps:packageUpgrade.items.comfort.assisted',
      'steps:packageUpgrade.items.comfort.vf',
      'steps:packageUpgrade.items.comfort',
    ],
    priceDisplayOnly: false,
    price: {
      base: 74,
      discounted: 35,
    },
    stepVariable: 'packageUpgrade',
    recommended: false,
    colors: [],
    select: {
      oId: '104',
      vId: '215',
      val: 'comfort',
      var: 'packageUpgrade',
      o: [
        ['coating', 'mc'],
        ['index', 'o150'],
      ],
    },
    nextStep: 34,
    cta: null,
    attributes: [],
  },
  {
    id: 105,
    name: 'packageUpgrade:premium-vf',
    variantId: 218,
    value: 'premium',
    title: 'Premium',
    desc: '',
    lookup: [
      'steps:packageUpgrade.items.premium.vf<2',
      'steps:packageUpgrade.items.premium.assisted',
      'steps:packageUpgrade.items.premium.vf',
      'steps:packageUpgrade.items.premium',
    ],
    priceDisplayOnly: false,
    price: {
      base: 169,
      discounted: 130,
    },
    stepVariable: 'packageUpgrade',
    recommended: false,
    colors: [],
    select: {
      oId: '105',
      vId: '218',
      val: 'premium',
      var: 'packageUpgrade',
      o: [
        ['coating', 'mc'],
        ['index', 'o150'],
      ],
    },
    nextStep: 34,
    cta: null,
    attributes: [
      {
        id: 3,
        name: 'index_40',
      },
      {
        id: 10,
        name: 'zone_single_50',
      },
      {
        id: 5,
        name: 'antiscratch',
      },
      {
        id: 7,
        name: 'antireflective',
      },
      {
        id: 9,
        name: 'lightweight',
      },
    ],
  },
  {
    id: 102,
    name: 'packageUpgrade:worldclass-vf',
    variantId: 208,
    value: 'worldclass',
    title: 'World Class',
    desc: '',
    lookup: [
      'steps:packageUpgrade.items.worldclass.vf<2',
      'steps:packageUpgrade.items.worldclass.assisted',
      'steps:packageUpgrade.items.worldclass.vf',
      'steps:packageUpgrade.items.worldclass',
    ],
    priceDisplayOnly: false,
    price: {
      base: 289,
      discounted: 250,
    },
    stepVariable: 'packageUpgrade',
    recommended: false,
    colors: [],
    select: {
      oId: '102',
      vId: '208',
      val: 'worldclass',
      var: 'packageUpgrade',
      o: [
        ['coating', 'ex'],
        ['index', 'othn'],
      ],
    },
    nextStep: 34,
    cta: null,
    attributes: [
      {
        id: 4,
        name: 'index_60',
      },
      {
        id: 12,
        name: 'zone_double_70',
      },
      {
        id: 5,
        name: 'antiscratch',
      },
      {
        id: 7,
        name: 'antireflective',
      },
      {
        id: 9,
        name: 'lightweight',
      },
      {
        id: 8,
        name: 'lotus',
      },
      {
        id: 13,
        name: 'discount_next_tinting',
      },
    ],
  },
]
